import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const KEY = "apa_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
  });

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const add = (part, qty = 1) => {
    setItems(prev => {
      const found = prev.find(i => i.part_id === part.part_id);
      if (found) return prev.map(i => i.part_id === part.part_id ? { ...i, quantity: i.quantity + qty } : i);
      return [...prev, {
        part_id: part.part_id, name: part.name, image_url: part.image_url,
        price: part.price, currency: part.currency, quantity: qty,
      }];
    });
  };
  const remove = (part_id) => setItems(prev => prev.filter(i => i.part_id !== part_id));
  const update = (part_id, qty) => setItems(prev => prev.map(i => i.part_id === part_id ? { ...i, quantity: Math.max(1, qty) } : i));
  const clear = () => setItems([]);
  const count = items.reduce((a, b) => a + b.quantity, 0);
  const subtotal = items.reduce((a, b) => a + b.price * b.quantity, 0);

  return (
    <CartContext.Provider value={{ items, add, remove, update, clear, count, subtotal }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
